module.exports = __webpack_public_path__ + "static/img/time-line-mob-gold-ar.91cb18e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/time-line-mob-gold-ar.png
// module id = 1061
// module chunks = 173